var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 7.16671H11.7917V5.29171C11.7917 3.10942 10.0156 1.33337 7.83333 1.33337C5.65104 1.33337 3.875 3.10942 3.875 5.29171V7.16671H3.25C2.5599 7.16671 2 7.7266 2 8.41671V13.4167C2 14.1068 2.5599 14.6667 3.25 14.6667H12.4167C13.1068 14.6667 13.6667 14.1068 13.6667 13.4167V8.41671C13.6667 7.7266 13.1068 7.16671 12.4167 7.16671ZM9.70833 7.16671H5.95833V5.29171C5.95833 4.25785 6.79948 3.41671 7.83333 3.41671C8.86719 3.41671 9.70833 4.25785 9.70833 5.29171V7.16671Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.44ab4766282612672dc88915e19d0937.svg";
export { ForwardRef as ReactComponent };